var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTimeGray16Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C5BDC025-905A-4004-9DD1-060D5B52D540_SVG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eraklient",
    transform: "scale(.72727)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#c1c1c1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arveldus---Tehingud---Grouped",
    transform: "translate(-756,-102)",
    fill: "none",
    stroke: "#c1c1c1",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#c1c1c1"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(566,101)",
    fill: "none",
    stroke: "#c1c1c1"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#c1c1c1"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#c1c1c1"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(191,2)",
    fill: "none",
    stroke: "#c1c1c1"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#c1c1c1"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#c1c1c1"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#c1c1c1"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#c1c1c1"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#c1c1c1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Time_Darker_20px",
    fill: "none",
    stroke: "#c1c1c1"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#c1c1c1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m20 10c0 5.5228-4.4772 10-10 10-5.5228 0-10-4.4772-10-10 0-5.5228 4.4772-10 10-10 5.5228 0 10 4.4772 10 10z"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "10.435 2.6087 10.435 10.435 5.2174 10.435"
  })))))))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTimeGray16Px);
export default __webpack_public_path__ + "static/media/Icon_Time_Gray_16px.a87b8e9469d0d2cc7dd8f75e518f97ac.svg";
export { ForwardRef as ReactComponent };